module.exports = __webpack_public_path__ + "img/crocodile.30c49ba2.png";